import type { AdvisorItemKind, AdvisorProductType } from './types';
import { category } from '@travel-planner/shared/schemas/enums';

export const ADVISOR_TYPE_CATEGORIES: Record<
  AdvisorProductType,
  readonly string[]
> = {
  hotels: [category.Accommodation],
  experiences: [category.Activity, category.Attraction],
  restaurants: [category.Dining],
};

export const ADVISOR_HASHTAG_CATEGORY: Record<
  AdvisorProductType,
  'hotel' | 'experience' | 'restaurant'
> = {
  hotels: 'hotel',
  experiences: 'experience',
  restaurants: 'restaurant',
};

export const kindFromCategory = (
  contentCategory: string | null
): AdvisorItemKind => {
  if (contentCategory === category.Accommodation) return 'hotel';
  if (contentCategory === category.Dining) return 'restaurant';
  return 'experience';
};
